import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, Input, OnChanges, PLATFORM_ID, inject } from '@angular/core';

@Directive({
  selector: '[appScrollIntoView]',
})
export class ScrollIntoViewDirective implements OnChanges {
  private platformId = inject(PLATFORM_ID);
  private elementRef = inject(ElementRef);

  @Input() appScrollIntoView: boolean | undefined;

  ngOnChanges(): void {
    if (isPlatformBrowser(this.platformId) &&
      coerceBooleanProperty(this.appScrollIntoView)) {
      requestAnimationFrame(() => { // Double RAF for extra safety
        (this.elementRef.nativeElement as HTMLElement).scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    }
  }
}
